import { action } from 'src/store/actions';

export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const SUCCESS_PRODUCTS = 'SUCCESS_PRODUCTS';
export const FAILURE_PRODUCTS = 'FAILURE_PRODUCTS';

export const fetchProducts = (productGroup: string, excludeSetProducts?: boolean, name?: string) =>
    action(FETCH_PRODUCTS, { productGroup, excludeSetProducts, name });
export const requestProducts = () => action(REQUEST_PRODUCTS);
export const requestProductsSuccess = (response: any) => action(SUCCESS_PRODUCTS, { response });
export const requestProductsFailure = (error: any) => action(FAILURE_PRODUCTS, { error });
